import { mobiClient } from '@/services/axiosConfig'
import { ConfirmTanReq, ConfirmTanRes, CreateTanReq, CreateTanRes, GetInstanceRes, GetLockedNumberRes, GetNumberListReq, GetNumberListRes, LockNumberReq, LockNumberRes, SaveContactInfoReq, UpdateImsiReq, UpdateImsiRes, UpdateUserInfoReq, UpdateUserInfoRes } from './types'

export const getLockedNumbers = async (isdn: string): Promise<GetLockedNumberRes | undefined> => {
  try {
    const res = await mobiClient.get('/newnumber/lockednumbers', { headers: { isdn } })
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const getNumberList = async (req: GetNumberListReq): Promise<GetNumberListRes | undefined> => {
  try {
    const res = await mobiClient.get('/newnumber/list?rateplan=PRSTA&pattern=' + (req.pattern ?? '________') + '&page=' + (req.page?.toString() ?? '1'))
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const lockNumber = async (req: LockNumberReq): Promise<LockNumberRes | undefined> => {
  try {
    const res = await mobiClient.post('/newnumber', req)
    return res.data
  } catch (e) {
    console.error(e)
  }
}

export const updateImsi = async (req: UpdateImsiReq): Promise<UpdateImsiRes | undefined> => {
  try {
    const res = await mobiClient.post('/newnumber/saveimsi', req)
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const updateUserInfo = async (req: UpdateUserInfoReq): Promise<UpdateUserInfoRes | undefined> => {
  try {
    const res = await mobiClient.post('/newnumber/saveinfo', req)
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const getInstance = async (id: string): Promise<GetInstanceRes | undefined> => {
  try {
    const res = await mobiClient.get('/newnumber', { headers: { id } })
    return res.data
  } catch (e) {
    console.error(e)
  }
}

export const createTan = async (req: CreateTanReq): Promise<CreateTanRes | undefined> => {
  try {
    const res = await mobiClient.post('/newnumber/tancreate', req)
    return res.data
  } catch (e) {
    console.error(e)
  }
}

export const confirmTan = async (req: ConfirmTanReq): Promise<ConfirmTanRes | undefined> => {
  try {
    const res = await mobiClient.post('/newnumber/tanconfirm', req)
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const saveContactInfo = async (req: SaveContactInfoReq): Promise<UpdateUserInfoRes | undefined> => {
  try {
    const res = await mobiClient.post('/newnumber/savecontactinfo', req)
    return res.data
  } catch (e) {
    console.error(e)
  }
}

export const createNumber = async (id: string): Promise<UpdateUserInfoRes | undefined> => {
  try {
    const res = await mobiClient.post('/newnumber/createnumber', { id })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
